import React, { Fragment } from 'react';
import type { Tools } from '../../../core/types';
import withEventTracking from '../../../utilities/withEventTracking';
import Element from '../../../core/Element';

export interface ClickableDotProps {
  onClick?: () => void;
  children?: React.ReactNode;
  tools?: Tools;
  active: boolean;
  index: number;
  totalItems: number;
}
const ClickableDot = ({
  onClick,
  children,
  active,
  index,
  totalItems,
}: ClickableDotProps) => {
  return (
    <Element
      Component="button"
      type="button"
      style={{
        margin: 0,
        padding: 0,
        background: 'transparent',
        border: 0,
        display: 'inline-block',
        cursor: 'pointer',
      }}
      theme={{
        focusDark: true,
      }}
      onClick={onClick}
      data-dot="true"
      aria-label={`Slide ${index + 1} of ${totalItems}`}
      aria-current={active}
    >
      <Fragment>
        <Element Component="span" theme={{ visuallyHidden: true }}>{`Slide ${
          index + 1
        } of ${totalItems}`}</Element>
        {active ? (
          <Element Component="span" theme={{ visuallyHidden: true }}>
            Currently Selected Slide
          </Element>
        ) : null}
        {children}
      </Fragment>
    </Element>
  );
};

export default withEventTracking<ClickableDotProps>(ClickableDot);
